<template>
  <div>
    <ui-heading tag="h3" no-top-margin>
      {{ ruleChecks.label }}
    </ui-heading>
    <ul class="list">
      <li
        v-for="item in ruleChecks.items"
        :key="item.key"
        :class="['item', { 'missing-data': item.missingData }]"
      >
        <icon name="check-circle" v-if="item.success" class="icon success" />
        <icon name="alert-circle" v-else-if="item.fail" class="icon fail" />
        <icon name="alert-circle" v-else class="icon unavailable" />
        <checks-item :item="item" />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getters } from "@/store";
import { CHECK_REASON, CHECK_STATUS, ROUTE_NAMES } from "@/router/constants";
import { SCREENING_QUERY_PARAMS, THRESHOLD_VALUE } from "@/constants/screening";
import { getReasonsLabels } from "@/utils/checks";
import ChecksItem from "./ChecksItem.vue";

export default {
  components: { ChecksItem },
  computed: {
    ...mapGetters([getters.currentIdentification, getters.currentDocumentData]),
    screeningRoute() {
      if (!this.currentDocumentData) return null;
      const { firstName, lastName, dateOfBirth } = this.currentDocumentData;
      const { NAME, BIRTH_DATE, THRESHOLD } = SCREENING_QUERY_PARAMS;
      const query = {
        [THRESHOLD]: THRESHOLD_VALUE
      };
      const searchTerms = [];
      if (firstName) searchTerms.push(firstName);
      if (lastName) searchTerms.push(lastName);
      if (searchTerms.length > 0) query[NAME] = searchTerms.join(" ");
      if (dateOfBirth) query[BIRTH_DATE] = dateOfBirth;
      return {
        name: ROUTE_NAMES.SANCTION_SEARCH,
        query
      };
    },
    ruleChecks() {
      return {
        label: this.$t("checks_rules_heading"),
        items: this.currentIdentification?.data?.rules?.map(rule => ({
          key: rule.name,
          label: this.$tIf({
            key: `checks_rules.${rule.name}_${rule.status}`
          }),
          reasonLabels: getReasonsLabels(
            rule.reasons,
            "checks_rules_reason",
            this.$tIf
          ),
          missingData: !!rule.reasons?.includes(
            CHECK_REASON.MISSING_REQUIRED_DOCUMENT_DATA
          ),
          success: rule.status === CHECK_STATUS.SUCCESS,
          unavailable: rule.status === CHECK_STATUS.UNAVAILABLE,
          fail: rule.status === CHECK_STATUS.FAIL,
          statusText: this.getStatusText(rule.status)
        }))
      };
    }
  },
  methods: {
    getStatusText(status) {
      switch (status) {
        case CHECK_STATUS.SUCCESS:
          return this.$t("check_status.success");
        case CHECK_STATUS.FAIL:
          return this.$t("check_status.fail");
        case CHECK_STATUS.UNAVAILABLE:
        default:
          return this.$t("check_status.unavailable");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.list {
  padding: 0;
  margin: 0;
  font-size: 1rem;
  list-style: none;
}
.item {
  position: relative;
  padding-left: 1.5rem;

  & + & {
    margin-top: 0.5rem;
  }

  &.missing-data {
    color: var(--text-color-dimmed);

    .icon {
      fill: currentColor;
    }
  }
}
.icon {
  position: absolute;
  left: 0;
  width: 1.2rem;
  height: 1.2rem;
  &.success {
    fill: var(--text-success);
  }
  &.unavailable {
    fill: var(--text-warning);
  }
  &.fail {
    fill: var(--text-danger);
  }
}
.info-link {
  display: inline-block;
}
.link-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  vertical-align: bottom;
}
.refresh-button.refresh-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 1.5em;
  padding: 0 0 0 0.5em;
  vertical-align: bottom;
}
.refresh-icon {
  width: 1.5rem;
}
</style>
